import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { AssignOrderNoTab } from 'src/app/core/helpers/hand-accesibility/assign-order-no-tabs';
import { RoutingPath } from './../../configs/routing-path';

@Component({
    selector: 'app-nav-dash',
    templateUrl: './nav-dash.component.html',
    styleUrls: ['./nav-dash.component.scss'],
    standalone: false
})
export class NavDashComponent implements OnInit {
  @ViewChild('itemPQRS', {static: true}) itemPQRS: ElementRef;
  @ViewChild('AffilateRetreat', {static: true}) AffilateRetreat: ElementRef;


  public urlHome;
  public urlAffiliation;
  public urlRetreat;
  public urlBusinessInformation;
  public urlWorkersInformation;
  public urlPqrs;
  public showMenu = false;
  public showMenuAffilateRetreat = false;
  public dropActive: boolean;

  constructor(private render: Renderer2) {
  }

  ngOnInit() {
    this.urlHome = RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.home.path;
    this.urlAffiliation = RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.affiliation.path;
    this.urlRetreat = RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.retreat.path;
    this.urlBusinessInformation = RoutingPath.appRouting.components.business_information.path + '/' + RoutingPath.appRouting.components.business_information.pages.home.path;
    this.urlWorkersInformation = RoutingPath.appRouting.components.workers_information.path;
    this.urlPqrs = RoutingPath.appRouting.components.pqrs.path;
    AssignOrderNoTab.setTabsIndexNonFocus();

    this.render.listen(this.itemPQRS.nativeElement, 'click', (event) => {
      this.hideToggle();
    });

    this.render.listen(this.AffilateRetreat.nativeElement, 'click', (event) => {
      this.hideToggle();
    });

  }

  fshowMenu(){
    this.showMenu = !this.showMenu;
    this.showMenuAffilateRetreat = false;
    // this.render.removeAttribute(this.itemMenuCustomer.nativeElement,"aria-expanded");
    // this.render.setAttribute(this.itemMenuCustomer.nativeElement,"aria-expanded","true");

  }

  fshowMenuAffilateRetreat(){
    this.showMenuAffilateRetreat = !this.showMenuAffilateRetreat;
    this.showMenu = false;
    this.render.removeAttribute(this.AffilateRetreat.nativeElement,"aria-expanded");
    this.render.setAttribute(this.AffilateRetreat.nativeElement,"aria-expanded","true");
    this.render.addClass(this.AffilateRetreat.nativeElement,"is-active");
  }

  hideToggle(event? : any){
    this.showMenu = false;
    this.showMenuAffilateRetreat = false;
    // this.render.removeAttribute(this.itemMenuCustomer.nativeElement,"aria-expanded");
    // this.render.setAttribute(this.itemMenuCustomer.nativeElement,"aria-expanded","false");

  }


  @HostListener('document:keydown.escape', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.code=='Escape'){
      this.showMenu = false;
      this.showMenuAffilateRetreat = false;
    }
  }
}
